<template>
  <RevCard class="flex flex-row items-start p-16">
    <component :is="getInfoIcon(instruction.icon)" data-test="banner-icon" />
    <div class="ml-16">
      <h2 class="body-2-bold mb-8 mt-4">{{ instruction.title }}</h2>
      <p class="text-static-default-low body-2 inline-block">
        {{ instruction.body }}
      </p>
      <RevTag
        v-if="instruction.timeLeft"
        :label="instruction.timeLeft"
        variant="secondary"
      />

      <div v-if="hasActions" class="mt-12 flex gap-12">
        <RevButton
          v-for="(button, index) in actions"
          :key="button.id"
          :data-qa="button.id"
          :loading="button.loading"
          size="small"
          :variant="getVariant(index)"
          @click="sendAction(button.id)"
        >
          {{ button.label }}
        </RevButton>
      </div>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { BuybackOrderDetails } from '@backmarket/http-api/src/api-specs-buyback/seller/refurbisher.types'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevTag } from '@ds/components/Tag'

import type { InfoBannerActions } from '~/scopes/buyback/pages/orderDetails/OrderDetails.vue'
import { REFURBISHER_ICONS } from '~/scopes/buyback/pages/orderDetails/components/ActionBanner/constants'

const props = defineProps<{
  instruction: BuybackOrderDetails['instruction']
  actions: InfoBannerActions
}>()

const emit = defineEmits(['action'])

const hasActions = computed(() => !isEmpty(props.actions))

function getInfoIcon(iconId: string) {
  return REFURBISHER_ICONS[iconId as keyof typeof REFURBISHER_ICONS]
}
function getVariant(index: number) {
  return index === 0 ? 'primary' : 'secondary'
}
function sendAction(buttonId: string) {
  emit('action', { id: buttonId })
}
</script>
